/* ma-search-articles.js
   Extends the search overlay to show blog article results below product results.
   Uses MutationObserver so it works independently of the inline overlay JS
   and doesn't require any changes to that code's logic.

   Load order: after the header section's inline <script>.
   Requires: ma-search-overlay__art-* CSS (in ma-search-fix.css).
*/

(function () {
  'use strict';

  var input, resultsEl, artTimer, lastArtQ = '';

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Inject (or refresh) the article results section inside the overlay */
  function injectArticles(arts) {
    if (!resultsEl) return;

    /* Remove a previous article section if present */
    var old = resultsEl.querySelector('.ma-search-overlay__art-section');
    if (old) old.remove();

    if (!arts || !arts.length) return;

    var section = document.createElement('div');
    section.className = 'ma-search-overlay__art-section';

    var html = '<span class="ma-search-overlay__art-label">From the Blog</span>';
    html += '<ul class="ma-search-overlay__art-list">';
    arts.forEach(function (a) {
      html += '<li><a href="' + esc(a.url) + '" class="ma-search-overlay__art-link">'
            + esc(a.title) + '</a></li>';
    });
    html += '</ul>';
    section.innerHTML = html;

    /* Insert before the "View all results" footer if it exists */
    var footer = resultsEl.querySelector('.ma-search-overlay__footer');
    if (footer) {
      resultsEl.insertBefore(section, footer);
    } else {
      resultsEl.appendChild(section);
    }
  }

  /* Fetch articles from Shopify predictive search API */
  function fetchArticles(q) {
    if (q === lastArtQ) return;
    lastArtQ = q;

    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=article&resources[limit]=5';

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        /* Abort if the query has changed since we sent this request */
        if (!input || input.value.trim() !== q) return;
        var arts = (d.resources && d.resources.results && d.resources.results.articles) || [];
        injectArticles(arts);
      })
      .catch(function () { /* silently ignore errors */ });
  }

  /* Called whenever the overlay results div changes */
  function onResultsChanged() {
    var q = input ? input.value.trim() : '';

    /* Clear article injection if query is too short or results cleared */
    if (q.length < 2) {
      lastArtQ = '';
      var old = resultsEl && resultsEl.querySelector('.ma-search-overlay__art-section');
      if (old) old.remove();
      return;
    }

    /* Debounce — wait briefly so the product results settle first */
    clearTimeout(artTimer);
    artTimer = setTimeout(function () { fetchArticles(q); }, 120);
  }

  function init() {
    input     = document.getElementById('ma-search-input');
    resultsEl = document.getElementById('ma-search-results');
    if (!input || !resultsEl) return;

    var observer = new MutationObserver(onResultsChanged);
    observer.observe(resultsEl, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
